<template>
  <EuiContainer>
    <EuiGrid class="mx-0 mt-2">
      <searchCard title="Suppression des doublons"/>
      <EuiGridRow v-if="getterIsLaunch" class="mt-4" >
        <EuiBlock title="Résultat">
          <template v-slot:actions>
            <EuiButton
              v-if="getterResult.length === 1"
              color="primary"
              variant="raised"
              @click="validation">
            Supprimer
          </EuiButton>
          </template>
          <resultCard />
        </EuiBlock>
      </EuiGridRow>
    </EuiGrid>
    <ConfirmationDialog
        v-if="isEnabledDialog"
        :isOpen="isConfirmationDialogOpen"
        @confirmation="confirmation"
        @close-dialog="closeDialog">
      <span v-html="confirmationMessage"></span>
    </ConfirmationDialog>
  </EuiContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import searchCard from '@/components/searchCard.vue';
import resultCard from '@/components/resultCard.vue';
import ConfirmationDialog from '@/components/confirmationDialog.vue';

export default {
  name: 'pages.delete.duplicates',
  components: {
    searchCard,
    resultCard,
    ConfirmationDialog,
  },
  data() {
    return {
      isConfirmationDialogOpen: false,
      isDeletedBoxe: false,
    };
  },
  mounted() {
    this.storeResetChangeRoute();
  },
  computed: {
    ...mapGetters({
      getterSession: 'auth/session',
      getterIsLaunch: 'application/isLaunch',
      getterResult: 'boxes/result',
    }),
    isEnabledDialog() {
      return this.getterResult.length === 1;
    },
    confirmationMessage() {
      return `Êtes-vous certain de vouloir supprimer le coffre <b>${this.getterResult[0].userId}</b> ?`;
    },
  },
  methods: {
    ...mapActions({
      storeResetChangeRoute: 'application/resetChangeRoute',
      storeDeleteDuplicateBoxe: 'boxes/deleteDuplicateBoxe',
      storeSearchMatches: 'boxes/getMatchesBoxes',
      storeStartLoading: 'application/startLoading',
      storeFinishLoading: 'application/finishLoading',
    }),
    closeDialog() {
      this.isConfirmationDialogOpen = false;
    },
    confirmation() {
      this.closeDialog();
      this.storeStartLoading();
      this.storeDeleteDuplicateBoxe({
        sessionId: this.getterSession.token,
        userId: this.getterResult[0].userId,
      }).then(() => {
        this.storeSearchMatches({
          userId: this.getterResult[0].userId,
          sessionId: this.getterSession.token,
        }).then(() => {
          this.storeFinishLoading();
          this.isDeletedBoxe = true;
        });
      }).catch(() => {
        this.storeFinishLoading();
      });
    },
    validation() {
      this.isConfirmationDialogOpen = true;
    },
  },
};
</script>
